let $ = jQuery.noConflict(),
	devMode,
	body,
	mobileCheck = false,
	currentY,
	pageTransition,
	pageTransitionEnabled = false,
	barbaInitialized,
    loadScript,
	resizeCallbacks = [],
	mobileResizeCallbacks = [],
	barbaCallbacks = [],
    woocommerce = true;

$(function () {
	initStarterKit();
	new BlockSlideDown();
	new EditorText();
    new Faq();
	new MainNavigation();
	new PlayerVideo();
    new Select();
    new ShopMap();
    new TestimonySlider();
    new Visit();

	// Composants Mobile & Desktop
	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
	}
});

function initStarterKit() {
	body = $('body');
	mcubeDebug();
	mobileCheck = new MobileCheck();
	new ResizeEvents();
	new AppearOnScroll();
	pageTransition = new CustomPageTransition();
	new BasePageTransition();
	new DataLink();
	new Forms();
	new GDPR();
    loadScript = new LoadScripts();
	new MadeByMcube();
	new Parallax();
	new TextAppear();

	if( woocommerce ){
        new WoocommerceSingleProduct();
        new WoocommerceButton();
        new WoocommerceFilterShop();
    }

}

function scrollListener(newY) {

}
